import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { Translate, withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';
import { domainActions } from '../../store/domainStore';
import ModalInner from '../layoutItems/modalInner';
import ResponsiveTable from '../layoutItems/responsiveTable';
import { hasPermission } from '../../store/apiWrapper';
import BbCheckbox from "../styling/bbCheckbox";

class PortfolioConfirmationPopup extends React.Component {
    state = {
        amlForceNew: true,
        allowCustomer: true
    }
    render() {
        let isAml = this.props.registry === 'aml';
        return (
            <React.Fragment>
                <ModalInner title={this.props.translate('Search.Common.Bulk')} close={this.props.close}>
                    <React.Fragment>
                        <ResponsiveTable>
                            <table className="table table-report-section-2 table-cee-disclaimer w-100">
                                <tbody>
                                    {this.props.registry !== 'aml' && (
                                        <tr className="colorize">
                                            <td className="bold">
                                                <Translate id='Search.Common.Bulk.Searches' />:
                                            </td>
                                            <td>
                                                {this.props.bulkCheck.numSearches}
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.registry !== 'aml' && (
                                        <tr className="colorize">
                                            <td className="bold">
                                                <Translate id='Search.Common.Bulk.Causes' />:
                                            </td>
                                            <td>
                                                {this.props.bulkCheck.numCauses}
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.registry !== 'aml' && this.props.bulkCheck.showMonetaryRow && (
                                        <tr className="colorize">
                                            <td className="bold" colSpan={2}>
                                                <Translate id='Search.Common.DownloadMonetaryObligationPart1' />
                                                {" " + this.props.bulkCheck.maxCauses + " "}
                                                <Translate id='Search.Common.DownloadMonetaryObligationPart2' />

                                            </td>

                                        </tr>
                                    )}
                                    {this.props.registry === 'aml' && (
                                        <tr className="colorize">
                                            <td className="bold">
                                                <Translate id='Search.Common.Bulk.Persons' />:
                                            </td>
                                            <td>
                                                {this.props.bulkCheck.numSearches}
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.registry === 'aml' && (
                                        <tr className="colorize">
                                            <td className="bold">
                                                <Translate id='Search.Common.Bulk.Companies' />:
                                            </td>
                                            <td>
                                                {this.props.bulkCheck.numCauses}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </ResponsiveTable>

                        <div className="has-text-centered" style={{ fontSize: ".875em", padding: "2em .3em 1em .3em" }}>
                            <React.Fragment>
                                <div style={{ marginBottom: "1em" }}>
                                    {
                                        (registry => {
                                            switch (registry) {
                                                case 'cee': return <Translate id='Search.Common.ExecutionRegistryQuestion' options={{ renderInnerHtml: true }} data={{ country: 'CZ' }} />
                                                case 'cre': return <Translate id='Search.Common.ExecutionRegistryQuestion' options={{ renderInnerHtml: true }} data={{ country: 'SK' }} />
                                                case 'aml': return <Translate id='Search.Aml.ConfirmationQuestion' />
                                                default: return null;
                                            }
                                        })(this.props.registry)
                                    }
                                </div>
                                {
                                    this.props.bulkCheck.isSuccess &&
                                    <Translate id='Search.Common.CreditConsumptionInfoWithBulk'
                                        data={{ buttonLabel: this.props.translate('Common.Yes.Upper'), account: this.props.bulkCheck.accountType, amount: this.props.bulkCheck.amountFormatted, disponible: this.props.bulkCheck.disponibleAmountFormatted }} />
                                }
                                {
                                    (this.props.registry === 'aml') && (
                                        this.props.bulkCheck.amount === 1.00 ?
                                            <Translate id='Search.Aml.CreditConsumptionInfo1Unit' data={{ accountType: this.props.bulkCheck.accountType, disponible: this.props.bulkCheck.disponibleAmount }} />
                                            :
                                            <Translate id='Search.Aml.CreditConsumptionInfoMultipleUnits' data={{ accountType: this.props.bulkCheck.accountType, units: this.props.bulkCheck.amount, disponible: this.props.bulkCheck.disponibleAmount }} />
                                    )
                                }
                                {isAml && <>
                                    {this.renderForceNewLabel(isAml)}
                                    {this.renderAllowCustomerLabel(isAml)}
                                </>
                                }
                            </React.Fragment>
                        </div>

                        <div className="modal-inner-buttons">
                            <button type='button' onClick={() => this.props.close()} className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                <Translate id='Common.No.Upper' />
                            </button>
                            <button type='button' onClick={() => this.props.yes(this.state.amlForceNew, this.state.allowCustomer)} className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                <Translate id='Common.Yes.Upper' />
                            </button>
                        </div>
                    </React.Fragment>
                </ModalInner>
            </React.Fragment>
        )
    }

    renderForceNewLabel = (isAml) => {
        return isAml ? <div className="tile" style={{ textAlign: 'left', marginTop: "1.5rem" }}>
            <span className="aml-special-span" style={{ lineHeight: "1.5em" }}>
                <BbCheckbox
                    style={{ display: "inline-flex", minHeight: "0px", lineHeight: "1.5em", verticalAlign: "middle", fontWeight: "bold" }}
                    label={this.props.translate("Aml.BulkRequest.ForceNew.Label")}
                    id="amlForceNew"
                    value={this.state.amlForceNew}
                    onChange={(v) => this.setState({ amlForceNew: v })}
                />
            </span>
        </div> : <></>
    }

    renderAllowCustomerLabel = (isAml) => {
        return isAml ? hasPermission(null, "AMLReuseRequest") && <div className="tile" style={{ textAlign: 'left' }}>
            <span className="aml-special-span" style={{ lineHeight: "1.5em" }}>
                <BbCheckbox style={{ display: "inline-flex", minHeight: "0px", lineHeight: "1.5em", verticalAlign: "middle", fontWeight: "bold" }}
                    id='allowCustomer'
                    label={this.props.translate("Aml.BulkRequest.AllowCustomer.Label")}
                    value={this.state.allowCustomer}
                    onChange={(v) => this.setState({ allowCustomer: v })}
                />
            </span>
        </div> : <></>;
    }


}
export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(PortfolioConfirmationPopup));